// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// stores form names which are shared across various modules in this area
export const BULK_EDITS_FILTER = 'bulk-edits-filter'
export const BULK_EDITS_FORM = 'bulk-edits-form'

export const BULK_EDITS_FILTER_DEFAULT_VALUES = Object.freeze({
  bandId: '',
  bulkMode: 'site',
  filterCheckbox: false,
  filterSelect: 'siteName',
  filterInput: '',
})
